export default __webpack_public_path__ + "static/media/single_add_icon_white.373b9c04.svg";